import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { setModalOrderCustomer } from '../../../../../redux/action/customer'
import ButtonsModal from '../../../../Elements/modal/ButtonsModal'
import { printRequestsThunk } from '../../../../../redux/thunk/order/printRequests'

const EVENT_Z_INDEX = 22

const PrintCanceledOrder = React.memo(() => {
	const selectedOrder = useSelector(store => store.order.selectedOrder)
	const showPrintCanceledOrder = useSelector(store => store.customerStore.modal.showPrintCanceledOrder)
	const dispatch = useDispatch()
	const { t } = useTranslation()

	const handleBack = useCallback(() => {
		dispatch(setModalOrderCustomer({ showPrintCanceledOrder: false }))
		dispatch(setModalOrderCustomer({ showOrder: true }))
	}, [dispatch])

	const printOrderClick = useCallback(async (isCanceledPrint = false) => {
		await dispatch(printRequestsThunk(selectedOrder?.orderId, 'CUSTOMER_RECEIPT_DUPLICATE', isCanceledPrint))
		await dispatch(printRequestsThunk(selectedOrder?.orderId, 'KITCHEN_RECEIPT'))
		dispatch(setModalOrderCustomer({ showPrintCanceledOrder: false }))
	}, [selectedOrder?.orderId, dispatch])

	const buttons = useMemo(() => [
		{ icon: 'print', text: t('order.modal.print_order'), onClick: () => printOrderClick(false), show: true },
		{ icon: 'print', text: t('order.modal.print_canceled_order'), onClick: () => printOrderClick(true), show: true },
	], [printOrderClick, t])

	return (
		<ButtonsModal isOpen={showPrintCanceledOrder}
									close={handleBack}
									title={t('order.modal.want_cancel_order')}
									size="small"
									zIndex={EVENT_Z_INDEX}
									returnZIndex={1}
									buttons={buttons} />
	)
})

PrintCanceledOrder.displayName = 'PrintCanceledOrder'
export default PrintCanceledOrder
